<template>
    <Container v-if="!TIWStore.IS_CLOSE">
        <section :class="containerSectionClassList">
            <InitWidgetLoader v-if="TIWStore.IS_INIT_WIDGET_LOADING" />
            <VisualEvaluation v-if="TIWStore.isCurrentStep('visualEvaluation')" />
            <ChooseDevice v-if="TIWStore.isCurrentStep('chooseDevice')" />
            <HowYouRateDevice v-if="TIWStore.isCurrentStep('howYouRateDevice')" />
            <EnterImei v-if="TIWStore.isCurrentStep('enterImei')" />
            <DownloadPhotos v-show="TIWStore.isCurrentStep('downloadPhotos')" />
            <OperatorExecuting v-if="TIWStore.isCurrentStep('operatorExecuting')" />
            <AddToCartWithoutSms v-if="TIWStore.isCurrentStep('addToCartWithoutSms')" />
            <SuccessfulEvaluation v-if="TIWStore.isCurrentStep('successfulEvaluation')" />
            <EvaluationResult v-if="TIWStore.isCurrentStep('evaluationResult')" />
            <AddToCart v-if="TIWStore.isCurrentStep('addToCart')" />
            <SigningWithoutSms v-if="TIWStore.isCurrentStep('signingWithoutSms')" />
            <ChooseSigningType v-if="TIWStore.isCurrentStep('chooseSigningType')" />
            <ReasonsCancellation v-if="TIWStore.isCurrentStep('reasonsCancellation')" />
            <ThanksYou v-if="TIWStore.isCurrentStep('thanksYou')" />
            <ThanksForOrder v-if="TIWStore.isCurrentStep('thanksForOrder')" />
        </section>

        <template #after-wrapper>
            <ImageFullScreen />
            <Carousel />
        </template>
    </Container>
</template>

<script lang="ts">
export default {
    name: "TradeInWidget",
    inject: ["appInstance", "widget"],
};
</script>

<script setup lang="ts">
import "@/scss/global.scss";
import { onMounted, computed } from "vue";

import Carousel from "@/components/carousel/carousel.vue";
import Container from "@/components/container/container.vue";
import ImageFullScreen from "@/components/imageFullScreen/imageFullScreen.vue";
import AddToCart from "@/components/modalSteps/addToCart/addToCart.vue";
import AddToCartWithoutSms from "@/components/modalSteps/addToCartWithoutSms/addToCartWithoutSms.vue";
import ChooseDevice from "@/components/modalSteps/chooseDevice/chooseDevice.vue";
import ChooseSigningType from "@/components/modalSteps/chooseSigningType/chooseSigningType.vue";
import DownloadPhotos from "@/components/modalSteps/downloadPhotos/downloadPhotos.vue";
import EnterImei from "@/components/modalSteps/enterImei/enterImei.vue";
import EvaluationResult from "@/components/modalSteps/evaluationResult/evaluationResult.vue";
import HowYouRateDevice from "@/components/modalSteps/howYouRateDevice/howYouRateDevice.vue";
import InitWidgetLoader from "@/components/modalSteps/initWidgetLoader/initWidgetLoader.vue";
import OperatorExecuting from "@/components/modalSteps/operatorExecuting/operatorExecuting.vue";
import ReasonsCancellation from "@/components/modalSteps/reasonsCancellation/reasonsCancellation.vue";
import SigningWithoutSms from "@/components/modalSteps/signingWithoutSms/signingWithoutSms.vue";
import SuccessfulEvaluation from "@/components/modalSteps/successfulEvaluation/successfulEvaluation.vue";
import ThanksForOrder from "@/components/modalSteps/thanksForOrder/thanksForOrder.vue";
import ThanksYou from "@/components/modalSteps/ThanksYou/ThanksYou.vue";
import VisualEvaluation from "@/components/modalSteps/visualEvaluation/visualEvaluation.vue";
import { suck, warn } from "@/helpers/consoleColors";
import { useTIWStore } from "@/stores/tiw/tiw";

const TIWStore = useTIWStore();

onMounted(() => {
    console.log("%c[TIWidget] -> APP is Mounted", suck);
    console.log("%c[TIWidget] -> press to any [Trade-In with Good] button", warn);
    TIWStore.initTradeInWithGood();
    TIWStore.INJECTED_TIW.current_api.onLoad();
    updateCssVariables();
});

const containerSectionClassList = computed<string[]>(() => {
    return ["tiw__modal", "tiw__step"];
});

function updateCssVariables() {
    if (TIWStore.customStyles.color.main) {
        document.documentElement.style.setProperty(
            "--custom-color-main",
            TIWStore.customStyles.color.main,
        );
    }
}
</script>
